import { createAppSlice } from '../app.slice';

const initialState = {
  entityCode: '',
  entityName: '',
  gender: '',
  taxpayerNumber: '',
  email: '',
  cellphoneNumber: '',
  questLastResponseDate: null,
  questNextResponseDate: null,
  questExpirationDate: null,
  questCanAnswer: null,
};

export const userInfoSlice = createAppSlice({
  name: 'userInfoSlice',
  initialState,
  reducers: {
    userInfoRequest: (state) => state,
    userInfoSucess: (_, action) => {
      // eslint-disable-next-line unused-imports/no-unused-vars
      const { id, type, language, ...userInfo } = action.payload[0];
      return userInfo;
    },
    userInfoFailure: (state) => state,
  },
});
